module.exports = __webpack_public_path__ + "img/1.8aaf14fe.png";